import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class AlwaysAuthGuard implements CanActivate {
  constructor(private Router: Router) { }
  canActivate() {
    sessionStorage.setItem('', 'true');

    const _isUser = JSON.parse(sessionStorage.getItem('userinfo'));
    console.log(_isUser);
    // if (_isUser === null || _isUser === undefined || _isUser === '' || _isUser.Store ==='' || _isUser.Store ===null) {
    //   this.Router.navigateByUrl('/');
    // } else {
    //   return true;
    // }

    if (_isUser === null || _isUser === undefined || _isUser === '' || _isUser.CustomeriD <= 0) {
      this.Router.navigateByUrl('/');
    } else {
      return true;
    }
  }
}
